import './App.css';
import PicketSchedule from './pages/PicketSchedule';

function App() {
  return (
    <div>
      <PicketSchedule/>
    </div>
  );
}

export default App;
